import React, { useContext } from "react";
import { PopUpGlobalContext } from "../../context/popup";
import {
  BtnUtils,
  ButtonUtils,
  ContainerUtils,
  HeaderUtils,
  ImageBoxUtils,
  MainUtils,
  RedirectUtils,
  RowUtils,
  TitleUtils,
} from "./styles/Utils";

export const Main: React.FC = ({ children, ...restProps }) => {
  const { PopUpOpen } = useContext(PopUpGlobalContext);

  return (
    <MainUtils open={PopUpOpen} {...restProps}>
      {children}
    </MainUtils>
  );
};

export const Container: React.FC = ({ children, ...restProps }) => (
  <ContainerUtils {...restProps}>{children}</ContainerUtils>
);

export const Row: React.FC<{ flexFin?: boolean }> = ({
  flexFin,
  children,
  ...restProps
}) => (
  <RowUtils fin={flexFin || false} {...restProps}>
    {children}
  </RowUtils>
);

export const ImageBox: React.FC = ({ children, ...restProps }) => (
  <ImageBoxUtils {...restProps}>{children}</ImageBoxUtils>
);

export const Header: React.FC = ({ children, ...restProps }) => (
  <HeaderUtils {...restProps}>{children}</HeaderUtils>
);

export const Title: React.FC = ({ children, ...restProps }) => (
  <TitleUtils {...restProps}>{children}</TitleUtils>
);

export const Button: React.FC<{ to: string }> = ({
  to,
  children,
  ...restProps
}) => (
  <ButtonUtils to={to} {...restProps}>
    {children}
  </ButtonUtils>
);

export const Link: React.FC<{ to: string }> = ({
  to,
  children,
  ...restProps
}) => (
  <RedirectUtils href={to} target='_blank' {...restProps}>
    {children}
  </RedirectUtils>
);

export const Trigger: React.FC = ({ children, ...restProps }) => (
  <BtnUtils {...restProps}>{children}</BtnUtils>
);
